import type { ParentComponent } from "../../lib/types";

const Unknown: ParentComponent = ({ children }) => <span>{children}</span>;

export { Unknown };
